import React from 'react';
import PropTypes from 'prop-types';

export default class Title extends React.Component {
  render() {
    const { text, ...style } = this.props;
    return (
      <div style={style}>{text}</div>
    );
  }
}

Title.propTypes = {
  text: PropTypes.string.isRequired
};

Title.defaultProps = {
  color: "#616365",
  fontSize: "20px",
  lineHeight: "32px"
};
